// extracted by mini-css-extract-plugin
export var resizer = "_gy-0";